module.exports = __webpack_public_path__ + "static/media/icon-settings.78104fd9.svg";